import { getRequestSingle } from '../services/requestHandler';
import { PlayerContractHistory } from '../models';

export const getPlayerContractHistory = async (playerId: number) => {
  const url = `player/getPlayerContractHistory?playerId=${playerId}`;
  const response = await getRequestSingle<PlayerContractHistory>('GetPlayerContractHistory', url);
  return response;
};
